module.exports = __webpack_public_path__ + "assets/img/famous.07f866e6.png";